<mat-form-field *ngIf="!shouldHide" appearance="fill">
  <mat-label>Select a frac</mat-label>
  <mat-select [(value)]="selectedFracIds" (selectionChange)="onSelectionChange($event.value)" multiple>
    <mat-option [value]="'all'" [selected]="selectedFracIds.includes('all')">All Fracs</mat-option>
    <mat-option *ngFor="let frac of fracs; trackBy: trackById" [value]="frac.id">
      {{ frac.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
